import { z } from 'zod';

export const formSchema = z.object({
  password: z.string().nonempty('errors.input.required'),
});

export type ISoftLoginFormData = z.infer<typeof formSchema>;
